module.exports = __webpack_public_path__ + "img/fork_base.1834ba7b.svg";